// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1449m","content":"styles_content__3qV63","row":"styles_row__1TVcH","footer":"styles_footer__3ELQD","phraseLength":"styles_phraseLength__3Oou1"};